export default __webpack_public_path__ + "static/home-4c1e2591a6b09abc1590ad380387d562.gif";